export default __webpack_public_path__ + "static/media/Group 3187@2x.2d63a2ad.png";